module.exports = __webpack_public_path__ + "img/downloadNowtc.5b6a00cd.png";